import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Process } from 'src/app/core/models/process.model';
import { ProcessService } from 'src/app/features/process/services/process.service';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card'; 
import { MatTabsModule } from '@angular/material/tabs'; 
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { ProcessStepsComponent } from '../../tabs/process-steps/process-steps.component'; 
import { ProcessTeamComponent } from '../../tabs/process-team/process-team.component';
import { ProcessCommunicationComponent } from '../../tabs/process-communication/process-communication.component';
import { ProcessDocumentationComponent } from '../../tabs/process-documentation/process-documentation.component';
import { ProcessCollectionDocumentsComponent } from '../../tabs/process-collection-documents/process-collection-documents.component';
import { ProcessRequirementsComponent } from '../../tabs/process-requirements/process-requirements.component';
import { ProcessRecurrencesComponent } from '../../tabs/process-recurrences/process-recurrences.component';
import { ProcessTimelineComponent } from '../../tabs/process-timeline/process-timeline.component';
import { ProcessViewedByComponent } from '../../tabs/process-viewed-by/process-viewed-by.component';

@Component({
  selector: 'app-process-detail',
  standalone: true,
  templateUrl: './process-fullview.component.html',
  imports:[
    CommonModule,
    MatCardModule,
    MatTabsModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    RouterModule,
    ProcessStepsComponent,
    ProcessTeamComponent,
    ProcessCommunicationComponent,
    ProcessDocumentationComponent,
    ProcessCollectionDocumentsComponent,
    ProcessRequirementsComponent,
    ProcessRecurrencesComponent,
    ProcessTimelineComponent,
    ProcessViewedByComponent
  ],
})
export class ProcessFullViewComponent implements OnInit {
  @Input() process!: Process;
  
  constructor(
    private route: ActivatedRoute,
    private processService: ProcessService
  ) {}

  ngOnInit(): void {
    const processId = this.route.snapshot.paramMap.get('id');
    if (processId) {
     //this.processService.getProcessById(processId).subscribe((process) => {
       // this.process = process;
      //});
    }
  }
}